<template>
  <touch-layout>
    <template #header_page_breadcrumb>
      <slot name="header_page_breadcrumb" />
    </template>
    <template #header_page_title>
      <slot name="header_page_title" />
    </template>
    <template #header_page_actions>
      <div class="px-3 md:px-10 flex items-center">
        <button class="btn btn-action" @click="create = true">Add Discount</button>
      </div>
    </template>
    <create
      v-if="create"
      @close="create = false"
      @add="addDiscount"
    />

    <slot name="menu" />
    <div class="flex flex-col grow">
      <div class="flex flex-col gap-5 p-5 grow bg-gray-200 w-full">
        <loading v-if="loading" :loading="true" class="bg-white p-5 border border-gray h-full" />
        <div
          v-else-if="filteredDiscounts.length > 0" 
          class="bg-white p-5 py-0 border border-gray overflow-y-auto"
          style="flex: 1 1 0; min-height: 200px;"
        >
          <div class="flex flex-col gap-2" style="flex: 1 1 0">
            <table class="table-pattern table-auto border-collapse" style="min-width: 500px;">
              <thead class="sticky top-0 bg-white z-30 w-full">
                <tr>
                  <th class="px-4 py-5 pt-10 text-left">Description</th>
                </tr>
              </thead>
              <tbody class="w-full">
                <tr v-for="discount in filteredDiscounts" :key="discount.id || discount.description">
                  <td class="px-4 py-2">
                    <input
                      v-model="discount.description"
                      class="bg-white p-2 rounded-lg border w-full"
                      style="max-width: 300px;"
                      type="text"
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="bg-white p-5 py-0 border border-gray flex justify-center items-center" style="flex: 1 1 0">
          <span>No Discounts Found.</span>
        </div>
      </div>
      <div class="sticky bottom-0 bg-white text-right p-3 border-t">
        <button
          class="btn btn-action btn-lg"
          :class="{
            'opacity-50 pointer-events-none bg-gray-500 border-gray-500':
              JSON.stringify(discounts) === JSON.stringify(originalDiscounts),
          }"
          @click="save()"
        >
          Save Changes
        </button>
      </div>
    </div>
  </touch-layout>
</template>

<script>

import Create from '@/components/business/productSetup/discounts/Create.vue';

export default {
  components: {
    Create
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'Error') {
      next()
    } else if (JSON.stringify(this.discounts) !== JSON.stringify(this.originalDiscounts)) {
      this.alertBox()
        .fire({
          title: 'There are unsaved changes',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Go Back',
          confirmButtonText: 'Continue',
        })
        .then((result) => {
          if (result.value) {
            next()
          }
        })
    } else {
      next()
    }
  },
  data() {
    return {
      discounts: [],
      originalDiscounts: [],
      loading: true,
      create: false,
    };
  },
  computed: {
    filteredDiscounts() {
      return this.discounts.filter(x => !x.delete)
    }
  },
  async created() {
    await this.getDiscounts()
  },
  methods: {
    addDiscount(discount) {
      this.discounts.push(discount)
      this.discounts.sort((a, b) => a.description.localeCompare(b.description))
      this.create = false
    },
    async getDiscounts() {
      this.discounts = await window.touch.staffListDiscountCategories()
      this.discounts.sort((a, b) => a.description.localeCompare(b.description))
      this.originalDiscounts = JSON.parse(JSON.stringify(this.discounts));
      this.loading = false
    },
    async save() {
      this.loading = true
      const changedItems = this.getChanged()
      try {
        await window.touch.staffUpdateDiscountCategories(changedItems)
      } catch (error) {
        if (error.status === 400) {
          this.alertBox().fire(error.popUp);
        } else {
          throw error
        }
      }
      await this.getDiscounts()
      this.loading = false
    },
    getChanged() {
      let changedDiscounts = [];
      if (JSON.stringify(this.discounts) !== JSON.stringify(this.originalDiscounts)) {
        for (let index = 0; index < this.discounts.length; index += 1) {
          const discount = this.discounts[index]
          const originalDiscount = this.originalDiscounts.find(x => x.id === discount.id)
          if (JSON.stringify(discount) !== JSON.stringify(originalDiscount) || !originalDiscount) {
            changedDiscounts.push({
              Id: discount.id,
              Description: discount.description
            });
          }
        }
      }
      return changedDiscounts
    },
  },
};
</script>